// extracted by mini-css-extract-plugin
module.exports = {"topImage":"StaffPage_topImage__3yOVc"};